"use strict";

var isArray = function isArray(arrayToCheck) {
  return Array.isArray(arrayToCheck);
};

var isFunction = function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]' || false;
};

module.exports = {
  isArray: isArray,
  isFunction: isFunction
};